<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h5>Recomendações ao Cliente</h5>
            
            <p class="titulo-separador">Um bom projeto de Eficiência Energética observa as seguintes práticas</p>
            <ul class="list-unstyled">
            <li>
                <i class="fa fa-angle-double-right "></i> Levantamento da Linha de Base, que é o cálculo do gasto de energia da
                situação anterior à implantação do projeto de eficiência energética, bem
                como das variáveis que impactam o consumo de energia.
            </li>
            <br/>
            <li class="mt-2">
                <i class="fas fa-angle-double-right "></i> Envolvimento de responsável técnico que possua: credenciamento nos
                órgãos competentes, experiência em projetos similares e com certificação,
                como por exemplo: CMVP (Certified Measurement and Verification
                Professional) ou CEN (Certified Energy Management).
            </li>
            <br/>
            <li class="mt-2">
                <i class="fas fa-angle-double-right "></i> No caso de o investimento ser implementado ou acompanhado por uma
                empresa terceirizada (exemplo de uma Empresa Especializada em Eficiência
                Energética - ESCO) ou um fornecedor de equipamentos, celebrar
                previamente ao início da implantação do Projeto, o(s) contrato(s) que irá(ão)
                disciplinar as responsabilidades, performance, cálculo de remuneração ou
                penalidade pelos desvios do comportamento esperado, tais como:
                <ul style="margin-left: 2%;">
                <li>Contrato de locação e operação de equipamento;</li>
                <li>Contrato com Modelo de Economia Garantida;</li>
                <li>Contrato de Performance no modelo de Economia Compartilhada; ou</li>
                <li>Contrato de Gestão de Utilidades.</li>
                </ul>
            </li>
            <br/>
            <li class="mt-2">
                <i class="fas fa-angle-double-right "></i> No caso de o investimento estar relacionado a implantação de um novo
                equipamento ou de um novo processo, procurar treinamento para operação,
                a fim de obter melhor benefício e trazer segurança na operação.
            </li>
            <br/>
            <li class="mt-2">
                <i class="fas fa-angle-double-right "></i> Ter um sistema de gestão de energia, se possível aderente à norma ISO
                50.001.
            </li>
            <br/>
            <li class="mt-2">
                <i class="fas fa-angle-double-right "></i> Ter um Plano de Medição e Verificação (M&V) das economias geradas, se
                possível aderente ao PIMVP (Protocolo Internacional de Medição e
                Verificação de Performance).
            </li>
            <br/>
            <li class="mt-2">
                <i class="fas fa-angle-double-right "></i> Após a implantação do projeto, efetuar uma avaliação da economia de
                energia, com profissional ou auditor independente de energia.
            </li>
            </ul>
            <hr>
        </div>
        </div>

        <p class="titulo-separador">Termos de aceite</p>

    <form [formGroup]="formGroup" *ngIf="formGroup">
        <div class="row">
            <div class="col-12">
                <div class="form-check mb-3">
                    <input class="form-check-input" type="checkbox" id="termoRelatorio" formControlName="termoRelatorio">
                    <label class="form-check-label" for="termoRelatorio">
                        Concordo em apresentar, em até 2 anos após a implantação das ações de eficiência 
                        energética, relatório dos benefícios alcançados com o projeto. Ou, caso o investimento 
                        seja de até R$ 400 mil, a apresentação de declaração, após um ano do prazo final de 
                        implantação do investimento.
                    </label>
                </div>

                <div class="form-check mb-3">
                    <input class="form-check-input" type="checkbox" id="termoPaineis" formControlName="termoPaineis">
                    <label class="form-check-label" for="termoPaineis">
                        Declaro que estou ciente de que o investimento em instalação de painéis solares não 
                        poderá representar mais que 30% do investimento apoiado e que estes investimentos 
                        não poderão ser considerados para o cálculo de economia do consumo de energia.
                    </label>
                </div>

                <div class="form-check mb-3">
                    <input class="form-check-input" type="checkbox" id="termoViabilidade" formControlName="termoViabilidade">
                    <label class="form-check-label" for="termoViabilidade">
                        Declaro que realizei avaliação de economia de energia e declaro que o projeto é 
                        financeiramente viável, ou que, por motivos estratégicos, o investimento possui valor para 
                        as atividades da empresa.
                    </label>
                </div>

                <div class="form-check mb-3">
                    <input class="form-check-input" type="checkbox" id="termoFaturamento" formControlName="termoFaturamento">
                    <label class="form-check-label" for="termoFaturamento">
                        Declaro que a empresa que irá obter o financiamento, objeto da solicitação de garantia 
                        do FGEnergia, não fatura mais que R$ 300 milhões/ano.
                    </label>
                </div>

                <div class="form-check mb-3">
                    <input class="form-check-input" type="checkbox" id="termoRecomendacoes" formControlName="termoRecomendacoes">
                    <label class="form-check-label" for="termoRecomendacoes">
                        Declaro que li as recomendações a seguir:
                    </label>
                    <ul style="margin-left: 2%;">
                        <li>um bom projeto de eficiência energética deve ter um profissional qualificado como responsável técnico para sua implantação, operação e manutenção.</li>
                        <li class="mt-2">Sempre que possível faça uma avaliação prévia do cenário atual de consumo de energia da empresa (um levantamento da linha de base dos gastos atuais de energia) e realize um plano de medição e verificação das economias geradas pelos investimentos de eficiência energética;</li>
                        <li class="mt-2">Indica-se sempre que o plano de eficiência energética apresente procedimentos que sigam normas de gestão de energia, tais como ISO 50.001 ou normas aplicáveis.</li>
                    </ul>
                </div>

                <div class="form-check mb-3">
                    <input class="form-check-input" type="checkbox" id="termoFalsidade" formControlName="termoFalsidade">
                    <label class="form-check-label" for="termoFalsidade">
                        Declaro que estou ciente de que a falsidade das informações ora prestadas poderá 
                        acarretar a perda de validade da outorga de garantia do FGEnergia, sem prejuízo da 
                        aplicação das sanções legais cabíveis, de natureza civil e penal.
                    </label>
                </div>
                <br/>
            </div>
        </div>
    </form>
</div>